import OperationForm from "./OperationForm";
export default function Depot() {
  return <OperationForm type="DEPOT" />;
}
